import { render, staticRenderFns } from "./Deposits.vue?vue&type=template&id=115a570f&scoped=true"
import script from "./Deposits.vue?vue&type=script&lang=js"
export * from "./Deposits.vue?vue&type=script&lang=js"
import style0 from "./Deposits.vue?vue&type=style&index=0&id=115a570f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115a570f",
  null
  
)

export default component.exports